import { RouteRecordRaw } from 'vue-router';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { VIEW_MODE } from '@/common/define/common.define';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';

const PREFIX_FAULT_ANALYSIS = 'fault_';

// 기존 경로는 새로운 경로로 redirect
const faultAnalysisMenu: RouteRecordRaw[] = [
  {
    path: '/fault-analysis/',
    name: `${PREFIX_FAULT_ANALYSIS}Fault Analysis`,
    redirect: '/application/performance-analysis/transaction-trend',
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_APPLICATION_ANALYSIS,
      invisibleViewMode: [VIEW_MODE.MAXGAUGE],
      viewport: VIEWPORT_TYPE.PA,
    },
    children: [
      {
        path: 'transaction-trend',
        name: `${PREFIX_FAULT_ANALYSIS}Transaction Trend Redirect`,
        redirect: '/application/performance-analysis/transaction-trend',
      },
      {
        path: 'exception-summary',
        name: `${PREFIX_FAULT_ANALYSIS}Exception Summary Redirect`,
        redirect: '/application/performance-analysis/exception-summary',
      },
      {
        path: 'trend-analysis',
        name: `${PREFIX_FAULT_ANALYSIS}Trend Analysis Redirect`,
        redirect: '/application/performance-analysis/trend-analysis',
      },
      {
        path: 'top-transaction-summary',
        name: `${PREFIX_FAULT_ANALYSIS}Top Transaction Summary Redirect`,
        redirect: '/application/performance-analysis/top-transaction-summary',
      },
      {
        path: 'top-sql-summary',
        name: `${PREFIX_FAULT_ANALYSIS}Top SQL Summary Redirect`,
        redirect: '/application/performance-analysis/top-sql-summary',
      },
      {
        path: 'performance-heatmap',
        name: `${PREFIX_FAULT_ANALYSIS}Performance Heatmap`,
        redirect: '/application/performance-analysis/performance-heatmap',
      },
      {
        path: 'daily-report',
        name: `${PREFIX_FAULT_ANALYSIS}Daily Report Redirect`,
        redirect: '/application/performance-analysis/daily-report',
      },
    ],
  },
];

export { faultAnalysisMenu, PREFIX_FAULT_ANALYSIS };
